import { getLoginUrl } from 'helpers/env';

export const goToLogin = (history, path) => {
  const url = path ?? getLoginUrl('');
  history.push(url);
};
